import React from 'react';
import Modal from '../Modal';
import './index.scss';

const Help = ({ user, step, setStep }) => {
  if (user === '' || step > 0) {
    return null;
  }

  const onClick = (event) => {
    event.preventDefault();

    setStep(1);
  };

  return (
    <Modal title='¿Cómo crear tu historia gráfica?'>
      <div className='help'>
        <div className='help__content'>
          <div className='help__text'>¡Arrastra tu dedo o el ratón por el lienzo para dibujar!</div>
          <div className='help__icon-text help__icon-text--lapiz'>Pulsa en este icono para escoger el grosor del trazo</div>
          <div className='help__icon-text help__icon-text--colores'>Pulsa en este icono para cambiar el color del trazo</div>
          <div className='help__icon-text help__icon-text--borrar'>Pulsa en este icono para borrar</div>
          <div className='help__icon-text help__icon-text--formas'>Pulsa en este icono para añadir formas y seleccionar su grosor</div>
          <div className='help__text'>
            Tienes 6 páginas para contar tu historia (a través de dibujos y textos). <br />
            <span className='help__marker'>Cuando hayas terminado una página, dale a GUARDAR para pasar a la</span> <span className='help__marker'>siguiente.</span>
          </div>
          <div className='help__text-small'>Recuerda que tu historia gráfica debe tener al menos 4 páginas.</div>
          <button className='button' onClick={onClick}>
            Comenzar
          </button>
        </div>

        <svg xmlns='//www.w3.org/2000/svg' version='1.1' className='svg-filters' style={{ display: 'none' }}>
          <defs>
            <filter id='marker-shape'>
              <feTurbulence type='fractalNoise' baseFrequency='0 0.15' numOctaves='1' result='warp' />
              <feDisplacementMap xChannelSelector='R' yChannelSelector='G' scale='30' in='SourceGraphic' in2='warp' />
            </filter>
          </defs>
        </svg>
      </div>
    </Modal>
  );
};

export default Help;
